import { Box, Button, Grow, Paper } from "@mui/material";
import { MediumText } from "components/typography";
import styles from "./QuantityRestriction.module.css";

interface Props {
  checked: boolean;
  handleClose: Function;
  text: string;
  onClickEvent: Function;
}


export default function QuantityRestriction(props: Props) {
  const { checked, text, onClickEvent } = props;
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          top: "40%",
          // position: "fixed",
          // left: "50%",
          // marginLeft: "-37.5%",
        }}
      >
        <Grow style={{ width: "100%", borderRadius: 16 }} in={checked}>
          <Paper sx={{ m: 1 }} elevation={4}>
            <Box className={styles.modalBox}  display={"flex"} gap={4} sx={{ m: 6 }}>
              <Box >
                <MediumText fWeight="bold" alignSelf="center">
                  {text}
                </MediumText>
              </Box>
              <Button onClick={(e) => { onClickEvent(e) }}>
                Ok
              </Button>
            </Box>
          </Paper>
        </Grow>
      </Box>
    </Box>

  )

}